import { useState, useEffect } from "react";
import "./course-challenge.css";
import InputSelect from "../../../../ui/atoms/inputs/input-select/InputSelect";
import Button from "../../../../ui/atoms/buttons/Button";
import Loading from "../../../../ui/atoms/loading/Loading";
//
import { onCreateLessonAssessment } from "../../services/course";
import { wait } from "../../../../core/utils/helpers";
import moment from "moment";
import Swal from "sweetalert2";

const CourseChallenge = ({
  stream_id,
  inscription_id,
  course_id,
  lesson_id,
}) => {
  const [isSending, setIsSending] = useState(false);

  const [assessmentMode, setAssessmentMode] = useState("");
  const [questionFrom, setQuestionFrom] = useState("");
  const [questionDifficulty, setQuestionDifficulty] = useState("");
  const [numberOfQuestions, setNumberOfQuestions] = useState("");
  const [invitationChannel, setInvitationChannel] = useState("");

  useEffect(() => {
    if (assessmentMode === "self-paced") {
      setInvitationChannel("");
    }
  }, [assessmentMode]);

  const onSubmit = async () => {
    if (assessmentMode === "") {
      Swal.fire({
        title: "Assessment Mode Not Selected",
        text: "Please select an assessment mode before proceeding",
        icon: "warning",
      });
      return;
    }
    if (questionFrom === "") {
      Swal.fire({
        title: "Origin of Question Not Selected",
        text: "Please select where questions are picked up from",
        icon: "warning",
      });
      return;
    }
    if (questionDifficulty === "") {
      Swal.fire({
        title: "Question Difficulty Not Selected",
        text: "Please select the difficulty level of question",
        icon: "warning",
      });
      return;
    }
    if (numberOfQuestions === "") {
      Swal.fire({
        title: "Number of Questions Not Selected",
        text: "Please select the number of questions for the assessment",
        icon: "warning",
      });
      return;
    }
    if (assessmentMode === "vs-students" && invitationChannel === "") {
      Swal.fire({
        title: "Invitation Channel Not Selected",
        text: "Please select the invitation channel for the assessment",
        icon: "warning",
      });
      return;
    }

    const localData = {
      streamId: stream_id,
      inscriptionId: inscription_id,
      courseId: course_id,
      lessonId: lesson_id,
      assessmentMode: assessmentMode,
      questionFrom: questionFrom,
      questionDifficulty: questionDifficulty,
      numberOfQuestions: numberOfQuestions,
      invitationChannel: invitationChannel,
      dates: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    };
    console.log({ localData });
    //
    setIsSending(true);
    Swal.fire({
      title: "Requesting new Assessment...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    await wait(700);
    //
    await onCreateLessonAssessment(localData)
      .then((response) => {
        console.log({ response });
        const _data = response?.data;
        Swal.close();
        setIsSending(false);
        //
        if (_data?.status) {
          Swal.fire({
            title: "Assessment Creation",
            text: _data?.message,
            icon: "success",
            confirmButtonText: "Got It!",
            confirmButtonColor: "#2840a8",
            didOpen: () => {
              const btn = Swal.getConfirmButton(); //
              btn.style.backgroundColor = "#2840a8";
              btn.style.color = "white";
            },
          });
          setAssessmentMode("");
          setQuestionFrom("");
          setQuestionDifficulty("");
          setNumberOfQuestions("");
          setInvitationChannel("");
        } else {
          Swal.fire({
            title: "Assessment Creation",
            text: _data?.message,
            icon: "info",
            confirmButtonText: "Got It!",
            confirmButtonColor: "#2840a8",
          });
        }
      })
      .catch((error) => {
        setIsSending(false);
        Swal.close();
        if (!error?.response) {
          Swal.fire({
            title: "Assessment Creation",
            text: "No server response",
            icon: "warning",
            confirmButtonText: "Got It!",
            confirmButtonColor: "#2840a8",
          });
        } else {
          Swal.fire({
            title: "Assessment Creation",
            text: error?.response?.data?.detail?.message,
            icon: "error",
            confirmButtonText: "Got It!",
            confirmButtonColor: "#2840a8",
          });
        }
      });
  };

  return (
    <div className="w-full h-full course-challenge">
      <div className="course-challenge-wrapper">
        <div className="w-full p-xs">
          <label>Assessment Mode</label>
          <InputSelect
            name={"mode"}
            placeholder={"Assessment Mode"}
            data={[
              {
                key: "self-paced",
                title: "Self-paced",
                is_activated: false,
              },
              {
                key: "vs-students",
                title: "Student vs Students",
                is_activated: false,
              },
            ]}
            value={assessmentMode}
            onChange={(e) => setAssessmentMode(e.target.value)}
          />
        </div>
        <div className="w-full p-xs">
          <label>Assessment Pickup Question from</label>
          <InputSelect
            name={"question_from"}
            placeholder={"Pickup Question from"}
            data={[
              {
                key: "questions-from-current-lesson",
                title: "Questions from current lesson only",
                is_activated: false,
              },
              {
                key: "questions-from-course-start-to-current-lesson",
                title: "Questions from course start to current lesson",
                is_activated: false,
              },
            ]}
            value={questionFrom}
            onChange={(e) => setQuestionFrom(e.target.value)}
          />
        </div>
        <div className="w-full p-xs">
          <label>Assessment Questions difficulty</label>
          <InputSelect
            name={"question_difficulty"}
            placeholder={"Question difficulty"}
            data={[
              {
                key: "beginner",
                title: "Beginner level",
                is_activated: false,
              },
              {
                key: "intermediate",
                title: "Intermediate level",
                is_activated: false,
              },
              {
                key: "advanced",
                title: "Advanced level",
                is_activated: false,
              },
              {
                key: "mixed",
                title: "Mixed level",
                is_activated: false,
              },
            ]}
            value={questionDifficulty}
            onChange={(e) => setQuestionDifficulty(e.target.value)}
          />
        </div>
        <div className="w-full p-xs">
          <label>Assessment Number of questions</label>
          <InputSelect
            name={"type"}
            placeholder={"Number of questions"}
            data={[
              {
                key: "random",
                title: "Random number of questions",
                is_activated: false,
              },
              {
                key: 5,
                title: "5 questions",
                is_activated: false,
              },
              {
                key: 10,
                title: "10 questions",
                is_activated: false,
              },
            ]}
            value={numberOfQuestions}
            onChange={(e) => setNumberOfQuestions(e.target.value)}
          />
        </div>
        {assessmentMode === "vs-students" && (
          <div className="w-full p-xs">
            <label>Assessment Invitation Channel</label>
            <InputSelect
              name={"invitation_channel"}
              placeholder={"Invitation Channel"}
              data={[
                {
                  key: "self-system-channel",
                  title: "Through Self-System Channel",
                  is_activated: false,
                },
                {
                  key: "code-channel",
                  title: "Through Code Channel",
                  is_activated: false,
                },
              ]}
              value={invitationChannel}
              onChange={(e) => setInvitationChannel(e.target.value)}
            />
          </div>
        )}
        <div className="w-fit-content m-auto p-md">
          {isSending ? (
            <Loading type={"type-1"} />
          ) : (
            <Button
              type={"button"}
              preferedStyle={"normal"}
              title={"Create assessment"}
              action={() => onSubmit()}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CourseChallenge;
